export default "__VITE_ASSET__CesAz7SK__"